import React, { useEffect } from "react";
import { authToken } from "../storage/authToken";
import { useCustomNavigate } from "../hooks";
import { useLocation } from "react-router-dom";
import isMobileDevice from "../utils/isMobileDevice";
import * as routeNames from "./routeName";

const ProtectedRoute = (props) => {

        const { Component, mobileOnly } = props

        const token = authToken()
        const navigate = useCustomNavigate()
        const location = useLocation()
        const isMobile = isMobileDevice()

        useEffect(() => {
                if (!token) {
                        if (mobileOnly) {
                                sessionStorage.setItem('postLoginRedirectPath', location.pathname)
                        }
                        navigate('/')
                } else if (mobileOnly && !isMobile) {
                        navigate(routeNames.DASHBOARD_ROUTE)
                }
        }, [token, navigate, mobileOnly, location.pathname, isMobile])

        if (!token) {
                return null
        }

        if (mobileOnly && !isMobile) {
                return null
        }

        return (<Component />)
};

export default ProtectedRoute;
